import { API } from '../../api';
import { axiosInstance } from '../../axios';
import { IHeaderMenu } from '@/shared/api/menus/getHeaderMenu/types';

interface Params {
  lang: string;
}

export const getHeaderMenu = async (params: Params) => {
  const result = await axiosInstance.get<IHeaderMenu>(API.getHeaderMenu, {
    params: {
      acf_format: 'standard',
      ...params,
    },
  });

  return result.data;
};
